import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import themeCss from '../components/sass/theme.module.scss'
import css from './sass/itemcard.module.scss'
import ItemBidInfo from './ItemBidInfo'

import BidSelector from './BidSelector'
import { getImageUrl } from '../util/images'
import CustomMarkdown from 'sites/auctions/components/CustomMarkdown'
import FavoriteItem from './FavoriteItem'
import { getItemUserStatus } from '../components/utils'
import { navigateFromAuctionToItem } from '../util/auctionScrollRestore'

export default function ItemCard({item, auction, auctionState, currentUserId, isCheckedIn, 
  setBidItem, setShowBidModal, updateBidModalAmount }) {

  const [itemBidAmount, setItemBidAmount] = useState()

  const [imageUrl, setImageUrl] = useState()

  const itemRoute = {
    pathname: '/auction/item',
    search: `?auctionId=${auction.AuctionCode}&itemId=${item.ItemCode}`,
  }

  const handleItemNavigation = (event) => {
    navigateFromAuctionToItem(event, itemRoute, auction.AuctionCode)
  }

  const linkObj = {
    itemCode: item.ItemCode,
    auctionCode: auction.AuctionCode,
    link: 'itemPage',
    onClick: handleItemNavigation,
  }

  // use effect for auction banner image
  useEffect(() => {
    const url = getImageUrl(auction?.AuctionCode, item?.ItemCode, item?.ImageFilename)
    setImageUrl(url)
  }, [auction, item])

  const isHighBidder = item.CurrentHighBidder === currentUserId

  if (auctionState === 'ended' && !isHighBidder) return <></> 

  const outlineClass = () => {
    const result = getItemUserStatus(auction, item, currentUserId)
    if (result) return themeCss[`outline-${result}`]
    else return ''

  }
  
  return (
    <div className={`${css['card-container']} ${themeCss['shadowed']} ${outlineClass()}`}>
      <Link className={css['card-image']} to={itemRoute} onClick={handleItemNavigation}>
        <img src={imageUrl} alt={`${item.Title}`} />
      </Link>

      <Link className={`${css['card-title']} ${themeCss['bold-nodecoration']}`} to={itemRoute} onClick={handleItemNavigation}>
        <span className={`${themeCss['truncate-twoline']}`}>
          {item.Title}
        </span>
      </Link>

      {auctionState !== 'before' && <ItemBidInfo auctionState={auctionState} item={item} 
        auction={auction} currentUserId={currentUserId} /> }

      <FavoriteItem auctionId={auction.AuctionId} itemId={item.ItemId}/>

      {(auctionState === 'started' && isCheckedIn) && (
        <>
          <div className={`${css['bid-selector-container']}`} >
            <BidSelector item={item} itemBidAmount={itemBidAmount} setItemBidAmount={setItemBidAmount}
            updateBidModalAmount={updateBidModalAmount}
            />
          </div>
          <button className={`${themeCss['button']} ${themeCss['FilledYellow']} ${css['place-bid-button']}`}
            onClick={() => {
                setBidItem(item)
                setShowBidModal(true)
                updateBidModalAmount(itemBidAmount)
              }}>
              PLACE BID
          </button>
        </>
        )}
      {(auctionState === 'started' && !isCheckedIn) && (
        <button className={`${themeCss['button']} ${themeCss['FilledYellow']} ${css['place-bid-button']}`}
          disabled={true}>
        Check In to Place Bid</button>)}

        <Link className={css['item-description-link']} to={itemRoute} onClick={handleItemNavigation}>
          <CustomMarkdown text={item.Description} noLineBreaks={true} cssClass={`${css['card-description']} ${themeCss['truncate-fourline']}`} linkObj={linkObj} />
        </Link>
    </div>
  )
}
